import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { userTypes } from "../../data/userTypes";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  customers: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the ridex customers
export const fetchCustomers = createAsyncThunk(
  "fetchCustomers/customers",
  async (
    { enqueueSnackbar, limit, page = 0, type, search, filter },
    thunkApi
  ) => {
    try {
      const response = await axiosInstance.get(`users`, {
        params: {
          user_type: userTypes.customer,
          limit,
          page: page + 1,
          type,
          ...(filter &&
            filter.status && {
              status: filter.status,
            }),
          ...(search !== "" && {
            search,
          }),
        },
      });
      return {
        data: response.data.data.data,
        meta: {
          total: response.data.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: fetch the ridex customer
export const fetchSingleCustomer = createAsyncThunk(
  "fetchSingleCustomer/customers",
  async ({ enqueueSnackbar, id }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`users/get-user/${id}`);
      return response.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create the ridex customers
export const createCustomers = createAsyncThunk(
  "createCustomers/customers",
  async ({ enqueueSnackbar, data, handleClose }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`customer-registration`, data);
      return {
        data: response.data.data,
        meta: {
          total: response.data.data.length,
        },
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete the ridex customers
export const deleteCustomers = createAsyncThunk(
  "deleteCustomers/customers",
  async ({ enqueueSnackbar, handleClose, userId }, thunkApi) => {
    try {
      const response = await axiosInstance.delete(
        `delete-user-account/${userId}`
      );

      return {
        data: response.data.data,
        meta: {
          total: response.data.data.length,
        },
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const customerSlice = createSlice({
  name: "customer",
  initialState,
  extraReducers: (builder) => {
    // TODO: fetch ridex customers
    builder.addCase(fetchCustomers.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchCustomers.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.customers = action.payload;
    });

    builder.addCase(fetchCustomers.rejected, (state, action) => {
      state.fetchLoading = false;
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: fetch single customer
    builder.addCase(fetchSingleCustomer.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchSingleCustomer.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.singleCustomer = action.payload;
    });

    builder.addCase(fetchSingleCustomer.rejected, (state, action) => {
      state.fetchLoading = false;
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: create customer member
    builder.addCase(createCustomers.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createCustomers.fulfilled, (state, action) => {
      state.isLoading = false;
      state.customers.data = [action.payload, ...state.customers.data];
      action.payload.enqueueSnackbar(
        "Customer member is created successfully.",
        {
          variant: "success",
        }
      );
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createCustomers.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: delete customer member
    builder.addCase(deleteCustomers.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteCustomers.fulfilled, (state, action) => {
      state.isLoading = false;
      state.customers.data = state.customers.data.filter(
        (customer) => customer?.id !== action.payload.data.id
      );
      state.customers.meta.total = state.customers.meta.total - 1;
      action.payload.enqueueSnackbar(
        "Customer member is deleted successfully.",
        {
          variant: "success",
        }
      );
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteCustomers.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });
  },
});

export default customerSlice.reducer;
